import classNames from 'classnames';
import React__default from 'react';
import { Tone } from '../../../../../../types.mjs';
import styles from './Footer.scss.mjs';

function Footer({
  children,
  unframed,
  tone
}) {
  return children ? /*#__PURE__*/React__default.createElement("footer", {
    className: classNames(styles.Footer, unframed && styles.unframed, tone === Tone.Magic && styles.toneMagic)
  }, children) : null;
}

export { Footer };
